export default __webpack_public_path__ + "static/media/NotoSerif.f575996b.woff2";